export const OPEN_PRINTER_MODAL = 'open_printer_modal';
export const CLOSE_PRINTER_MODAL = 'close_printer_modal';
export const GET_PRINTER = "get_printer";
export const GET_PRINTERS = "get_printers";
export const ADD_PRINTER = "add_printer";
export const UPDATE_PRINTER = "update_printer";
export const DELETE_PRINTER = "delete_printer";